"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFactory = void 0;
class DateFactory {
    create(data, parameters) {
        return new Date(parameters[0]);
    }
}
exports.DateFactory = DateFactory;
//# sourceMappingURL=DateFactory.js.map